<template>
  <v-col
    cols="12"
    sm="3"
    class="pb-10"
  >
    <v-btn
      color="primary"
      @click="incrementStep"
    >Continue</v-btn>
  </v-col>
</template>

<script>
export default {
  name: 'btnBenefitsContinue',
  data: () => ({
    temp: null,
  }),
  methods: {
    incrementStep() {
      if (this.$store.state.benefitsPacket.state.status !== 'Signed') {
        this.$store.commit('updateBenefitsStateStatus', 'In Progress');
      }
      const step = this.$store.state.benefitsPacket.state.step.split('');
      this.$store.commit('updateBenefitsStateStep', step[0] + (parseInt(step[1], 10) + 1));
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
